import { setCookie } from './utils';

// window.Termly?.on('initialized', (data) => {
//   console.debug('Termly initialized', data);
// });

/**
 * Save termly content to a cookie when consent changes,
 * so that I can read the preferences from the backend.
 * Otherwise you need to make an API call every time you want to check.
 *
 * It looks like this also runs on page load, which is good because the 'initialized' one doesn't seem to.
 *
 * https://support.termly.io/hc/en-us/articles/30710515703697-How-to-block-cookies-set-on-the-backend-using-the-consent-API
 * https://support.termly.io/hc/en-us/articles/30710543895697-Consent-API-documentation
 */
window.Termly?.on('consent', () => {
  // console.debug('Termly consent changed', data);
  const consentState = window.Termly?.getConsentState();
  setCookie('termlyConsent', consentState, 365);
});
